import { render, staticRenderFns } from "./ModalAddUserRestriction.vue?vue&type=template&id=4988c596"
import script from "./ModalAddUserRestriction.vue?vue&type=script&lang=js"
export * from "./ModalAddUserRestriction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports